const BASE_ROUTE = "/shop";

export const SHOP_ROUTES = {
  BASE: BASE_ROUTE,
  SUMMARY: `${BASE_ROUTE}/summary`,
} as const;
